import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { formatCurrency } from "@/lib/format";

export interface ApproveDialogProps {
  clientName: string;
  priceCharged: number;
  onClose: () => void;
  onConfirm: (applyFee: boolean) => void;
  isPending: boolean;
}

export function ApproveDialog({ clientName, priceCharged, onClose, onConfirm, isPending }: ApproveDialogProps) {
  const [applyFee, setApplyFee] = useState(false);

  return (
    <Dialog open onClose={onClose} className="sm:max-w-md">
      <DialogHeader onClose={onClose}>
        <DialogTitle>Odobri otkazivanje</DialogTitle>
        <DialogDescription className="mt-0 text-xs">
          Termin se otkazuje, klijent {clientName} se obavještava emailom.
        </DialogDescription>
      </DialogHeader>
      <DialogBody className="space-y-4">
        <label className="flex items-center gap-2 text-sm text-foreground">
          <Checkbox checked={applyFee} onCheckedChange={(v) => setApplyFee(v === true)} />
          Primijeni naknadu klijentu (standardni procenat)
        </label>
        <div className="rounded-xl bg-muted/30 p-3 text-sm">
          <p className="text-muted-foreground">Naplaćeno: {formatCurrency(priceCharged)}</p>
          <p className="text-muted-foreground">
            Konačan iznos naknade i povrata obračunava server nakon potvrde.
          </p>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button variant="outline" onClick={onClose} disabled={isPending}>Nazad</Button>
        <Button onClick={() => onConfirm(applyFee)} disabled={isPending}>Odobri</Button>
      </DialogFooter>
    </Dialog>
  );
}

export interface RejectDialogProps {
  onClose: () => void;
  onConfirm: (note: string) => void;
  isPending: boolean;
}

export function RejectDialog({ onClose, onConfirm, isPending }: RejectDialogProps) {
  const [note, setNote] = useState("");
  return (
    <Dialog open onClose={onClose} className="sm:max-w-md">
      <DialogHeader onClose={onClose}>
        <DialogTitle>Odbij zahtjev</DialogTitle>
        <DialogDescription className="mt-0 text-xs">
          Termin ostaje zakazan, terapeut dobija vaše obrazloženje.
        </DialogDescription>
      </DialogHeader>
      <DialogBody>
        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          maxLength={500}
          rows={3}
          placeholder="Npr. termin je preblizu, nadjite zamjenu"
        />
      </DialogBody>
      <DialogFooter>
        <Button variant="outline" onClick={onClose} disabled={isPending}>Nazad</Button>
        <Button variant="destructive" onClick={() => onConfirm(note.trim())} disabled={isPending || note.trim().length < 3}>
          Odbij
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
